import React, { useState } from 'react';
import { Box } from '@mui/material';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

export default function AdminLayout({ children, title }) {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <Box
            sx={{
                display: 'flex',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                bgcolor: '#f5f5f5',
            }}
        >
            {/* Sidebar */}
            <Sidebar
                open={sidebarOpen}
                onToggle={() => setSidebarOpen(!sidebarOpen)}
            />

            {/* Main Content Area */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                }}
            >
                {/* Navbar (fixed height) */}
                <Box sx={{ flexShrink: 0 }}>
                    <Navbar
                        title={title}
                        onMenuClick={() => setSidebarOpen(!sidebarOpen)}
                    />
                </Box>

                {/* SCROLL CONTAINER */}
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,     // 🔥 CRITICAL
                        overflowY: 'auto',
                        px: 2,
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
